// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingPage-loading-a239{position:fixed;inset:0;display:flex;align-items:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/page/base/LoadingPage/LoadingPage.module.scss"],"names":[],"mappings":"AAAA,0BACE,cAAA,CACA,OAAA,CACA,YAAA,CACA,kBAAA,CACA,sBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `LoadingPage-loading-a239`
};
module.exports = ___CSS_LOADER_EXPORT___;
